import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createWallet(context, walletData) {
    return new Promise((resolve, reject) => {
      axios
        .post('wallets', walletData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countWallets(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`wallets/count/?${query}`)
        .then(response => {
          context.commit('SET_WALLET_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchWallets(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`wallets/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          context.commit('SET_WALLET', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchWallet(context, walletId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`wallets/${walletId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchMyWallet(context) {
    return new Promise((resolve, reject) => {
      if (context.rootState.AppActiveUser.walletId) {
        axios
          .get(`wallets/${context.rootState.AppActiveUser.walletId}`)
          .then(response => {
            context.commit('UPDATE_USER_INFO', { wallet: response.data }, { root: true })
            resolve(response)
          })
          .catch(error => {
            notifyServerError(error)
            reject(error)
          })
      } else {
        reject('noWalletId')
      }
    })
  },
  removeWallet({ commit }, walletId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`wallets/${walletId}`)
        .then(response => {
          commit('REMOVE_RECORD', walletId)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editWallet(context, wallet) {
    return new Promise((resolve, reject) => {
      axios
        .put(`wallets/${wallet.id}`, wallet.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
